import { Component, Input } from '@angular/core';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';

@Component({
  selector: 'app-form-parere-view',
  templateUrl: './form-parere-view.component.html',
  styleUrls: ['./form-parere-view.component.css']
})
export class FormParereViewComponent {

  labelCreatoDaSistema = PropertiesSettings.LABEL_CREATO_DA_SISTEMA;

  @Input() ctxBodyFascicolo;
  constructor() {}
}
